import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebase";

export async function upsertPublicProfile(input: {
  uid: string;
  name?: string | null;
  photoURL?: string | null;
}) {
  await setDoc(
    doc(db, "publicProfiles", input.uid),
    {
      name: input.name ?? null,
      photoURL: input.photoURL ?? null,
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
}
